// Why detaching elements from a bundle failed
export enum BundleDetachErrorEnum {
    Forbidden = 'Forbidden',                    // 403: user lacks bundles:manage
    DifferentApartment = 'DifferentApartment',  // The target room isn't in the elements' apartment
    SeveralBundles = 'SeveralBundles',          // The elements aren't all in one bundle
    Failed = 'Failed'                           // Anything else
}
